angular.module('bmsApp.dashboard')
	.controller('JobResTaskCtrl', function ($scope,
												$rootScope,
												$state,
												$q,
												$timeout,
												$ngBootbox,
												ComplaintSvc,
												$filter
	) {
		var self = this;
		self.jobResolutionComplaintsOpenCount = 0;
		self.regularComplaintsOpenCount = 0;
		$rootScope.$on('complaintsLoaded', function (evt, counts) {
			self.methods.loadCount();
		});

		function init() {
			self.methods.loadCount();
			self.params = {
				jobResComplaints: {
					filter:{
						TodayJobRes:'',
					},
					sorting:{
						'created_at': 'desc',
					}
				},
				regularComplaints: {
					filter:{
						TodayRegular:'',
					},
					sorting:{
						'created_at': 'desc',
					}
				},
			}
		}

		function loadCount(){
			var promises = {
				countsRes: ComplaintSvc.alertCount(),
			};

			$q.all(promises)
				.then(function (responses) {
					self.jobResolutionComplaintsOpenCount = responses.countsRes.data.jobResTasksCount;
					self.regularComplaintsOpenCount = responses.countsRes.data.regularComplaintsCount;
				});
		}

		self.methods = {
			init: init,
			loadCount: loadCount,
		};

	});
